import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900 mt-4">

      <div className="text-center p-4 bg-white dark:bg-gray-800 shadow-lg rounded-2xl">
        <h1 className="text-2xl font-bold text-gray-600 dark:text-gray-400">404</h1>
        <h2 className="text-2xl mt-4 font-semibold text-gray-800 dark:text-white">Página no encontrada</h2>
        <p className="text-gray-600 dark:text-gray-300 mt-2 mb-6">
          Tienes un error en la ruta, la pagina no existe. =) 
        </p>
        <Link
          to="/app"
          className="inline-block px-6 py-2 text-white bg-gray-600 hover:bg-gray-700 rounded-lg transition-colors duration-200"
        >
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}
